// getters
export const GETTER_LIST_ACTIVITY = "GETTER_LIST_ACTIVITY";

// actions
export const ACTION_GET_LIST_ACTIVITY = "ACTION_GET_LIST_ACTIVITY";
export const ACTION_SET_LEVEL_ACTIVITIES = "ACTION_SET_LEVEL_ACTIVITIES";
export const ACTION_SET_LEVEL_ACTIVITIES_PURE =
  "ACTION_SET_LEVEL_ACTIVITIES_PURE";

// mutations
export const MUTATION_SET_LIST_ACTIVITY = "MUTATION_SET_LIST_ACTIVITY";



// WEBPACK FOOTER //
// ./src/store/modules/basic_level_activities/constants.js